export function extraFooterClasses(tabName: string | undefined) {
    if (tabName === 'Map') {
        return 'no-shadow';
    } else {
        return undefined;
    }
}
